var map = {
	"./apiSource.png": 1505,
	"./competitors.png": 1506,
	"./customerMaster.png": 1507,
	"./dashboard.png": 1508,
	"./demo.png": 1509,
	"./groupInstances.png": 1510,
	"./header-logout.png": 802,
	"./inactive.png": 1511,
	"./industry.png": 1512,
	"./industryMaster.png": 1513,
	"./live.png": 1514,
	"./logout.png": 803,
	"./profile.png": 1515,
	"./tenants.png": 1516,
	"./userManagement.png": 1517,
	"./webSource.png": 1518
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 118;